/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityInstanceFromJSONTyped, ActivityInstanceToJSON, } from "./ActivityInstance";
import { ActivityJobFromJSON, ActivityJobToJSON, } from "./ActivityJob";
import { ActivityTypeFromJSON, ActivityTypeToJSON, } from "./ActivityType";
/**
 * Check if a given object implements the ActivityInstanceJob interface.
 */
export function instanceOfActivityInstanceJob(value) {
    let isInstance = true;
    isInstance = isInstance && "activity" in value;
    isInstance = isInstance && "$type" in value;
    isInstance = isInstance && "duration" in value;
    return isInstance;
}
export function ActivityInstanceJobFromJSON(json) {
    return ActivityInstanceJobFromJSONTyped(json, false);
}
export function ActivityInstanceJobFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ...ActivityInstanceFromJSONTyped(json, ignoreDiscriminator),
        activity: ActivityJobFromJSON(json.activity),
        $type: ActivityTypeFromJSON(json.$type),
        duration: json.duration,
    };
}
export function ActivityInstanceJobToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ActivityInstanceToJSON(value, true),
        activity: ActivityJobToJSON(value.activity),
        $type: ActivityTypeToJSON(value.$type),
        duration: value.duration,
    };
}
